import React from "react";
import {Button, Dialog} from "@mui/material";
import {observer} from "mobx-react";
import './modal.scss'
import MediaLibrary from "../ProjectDashboard/MediaLibrary";
import CloseIcon from "@mui/icons-material/Close";
import {useStores} from "../../Hooks";
import {ObservableMap} from "mobx";
import {editNodeMedia, getNodeMedia} from "../../serverClientShared/sharedUtils";



const MediaLibraryModal = observer(() => {
    const {modalStore, dragStore, generalStore, procedureStore, editorStore} = useStores();

    function closeModal() {
        dragStore.resetDragMedia();

        if(generalStore.oldMediaFilesToBeReplaced?.length>0) {
            for (let i = 0; i < procedureStore.currentProcedure.NestedNodes?.length; i++) {
                for (let j = 0; j < generalStore.oldMediaFilesToBeReplaced?.length; j++) {
                    const matchedMediaFile = procedureStore.currentProcedure.NestedNodes[i].NodeMediaFilesRefs?.filter(fl => fl.FileId === generalStore.oldMediaFilesToBeReplaced[j].FileId)
                    if (matchedMediaFile?.length > 0) {
                        procedureStore.currentProcedure.NestedNodes[i].NodeMediaFilesRefs.forEach((file) => {
                            if (file.FileId === matchedMediaFile[0].FileId) {
                                editorStore.nodes.forEach(node => {
                                    const mediaFileObj = getNodeMedia(node.data.nodeData, "NodeMediaFilesRefs", procedureStore.currentProcedure);
                                    const {IsOverrideActive: isOverrideActive, FileRefs} = mediaFileObj;
                                    let mediaFiles = FileRefs ? [...FileRefs] : [];
                                    if (mediaFiles.filter(mf => mf?.FileId === generalStore.oldMediaFilesToBeReplaced[j]?.FileId)?.length > 0) {
                                        if (mediaFiles.filter(mf => mf.FileId === generalStore.newMediaFilesToBeReplaced[j].FileId).length === 0)
                                            mediaFiles.push(generalStore.newMediaFilesToBeReplaced[j]);
                                        if (generalStore.oldMediaFilesToBeReplaced) {
                                            for (let k = 0; k < generalStore.oldMediaFilesToBeReplaced?.length; k++)
                                                mediaFiles = mediaFiles.filter(mf => mf?.FileId !== generalStore.oldMediaFilesToBeReplaced[k]?.FileId);
                                        }
                                        node.data.nodeData = editNodeMedia(mediaFiles, isOverrideActive, node.data.nodeData, "NodeMediaFilesRefs", procedureStore.currentProcedure);
                                        editorStore.nodes.set(node.id, node);
                                    }
                                })
                            }
                        });
                    }
                }
            }
            editorStore.nodes = new ObservableMap(editorStore.nodes);
            procedureStore.sendUpdateMessage();
            generalStore.oldMediaFilesToBeReplaced = [];
            generalStore.newMediaFilesToBeReplaced = [];
        }
        modalStore.isMediaLibraryModalOpen = false;
    }

    return (
        <Dialog
            onClose={closeModal}
            open={modalStore.isMediaLibraryModalOpen}
            maxWidth='xxl'
            fullWidth
            className={'dialog huge-modal' + (dragStore.isDraggingFiles ? ' dragging' : '')}
            PaperProps={{className: 'huge-modal-paper'}}
        >
            <Button
                disableElevation
                disableFocusRipple
                disableRipple
                disableTouchRipple
                className='close-button'
                onClick={closeModal}
            >
                <CloseIcon/>
            </Button>

            {modalStore.isMediaLibraryModalOpen ? <MediaLibrary/> : <></>}
        </Dialog>
    )
});

export default MediaLibraryModal;
